import { fillQueryString } from './fillQueryString';
import { splitUrl } from './splitUrl';

interface Args {
  url: string;
  values: Record<string, string>;
}

/**
 * Resolves the `{{field}}` placeholders a link carries in its query string
 * against the values a form was submitted with.
 */
export const fillUrlPlaceholders = ({ url, values }: Args): string => {
  const { path, query, hash } = splitUrl(url);
  if (!query) return url;

  const filled = fillQueryString({ query, values });

  return `${path}${filled ? `?${filled}` : ''}${hash}`;
};
